var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBreakIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4195 7.25075L20.8981 5.77308C21.2565 5.41558 21.2565 4.83533 20.8981 4.47692C20.5397 4.1185 19.9603 4.1185 19.6019 4.47692L18.1233 5.95458C16.6805 4.762 14.8829 3.98283 12.9167 3.79675V2.83333H14.75C15.2569 2.83333 15.6667 2.42267 15.6667 1.91667C15.6667 1.41067 15.2569 1 14.75 1H9.25C8.74308 1 8.33333 1.41067 8.33333 1.91667C8.33333 2.42267 8.74308 2.83333 9.25 2.83333H11.0833V3.79675C6.20483 4.25967 2.375 8.37733 2.375 13.375C2.375 18.6825 6.6925 23 12 23C17.3075 23 21.625 18.6825 21.625 13.375C21.625 11.0503 20.7963 8.91633 19.4195 7.25075ZM15.3 17.775C15.135 17.8988 14.9416 17.9583 14.7509 17.9583C14.4723 17.9583 14.1973 17.8318 14.0167 17.5917L11.2667 13.925C11.1475 13.7664 11.0833 13.5739 11.0833 13.375V8.33333C11.0833 7.82642 11.494 7.41667 12 7.41667C12.506 7.41667 12.9167 7.82642 12.9167 8.33333V13.0697L15.4833 16.4917C15.7868 16.8968 15.7052 17.4716 15.3 17.775Z",
    fill: "#4FC0CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakIcon);
export default __webpack_public_path__ + "static/media/break-icon.09e09b9b4ab06d59e4b6b4f421d71581.svg";
export { ForwardRef as ReactComponent };